import { useRouteMatch } from 'react-router-dom';
import { COMMON_ERROR, NO_MATCH } from '../constants/routeTemplates';

// Because the 404 page can be rendered on the route "*"
// Need to request the correct SEO and meta data for it, how would it be rendered on the route for common error
export const useCustomRouteMatch = () => {
  const { path, params, ...rest } = useRouteMatch();
  return {
    path: path === NO_MATCH ? COMMON_ERROR : path,
    params: path === NO_MATCH ? { status: 404 } : params,
    ...rest,
  };
};
